<div class="header__langs">
  <img class="selected__lang" src="{{ 'assets/img/langs/' + currentLang + '.svg' }}" />
  <app-ph-input
    [validation]="'required'"
    [isWhite]="isWhite"
    isLanguage="true"
    type="select"
    name="language"
    [selectArray]="languages"
    bindLabel="code"
    [searchable]="false"
    [correctForm]="form"
    [initValue]="storage.get('lang') && storage.get('lang').toUpperCase()"
    [clearable]="false"
    (phInputChange)="changedLanguage($event)"
  ></app-ph-input>
</div>
